import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import { ManualService } from '@app/core/auth/_services/manual.service';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'kt-download-manual',
  template: `
      {{'MANUAL.DOWNLOAD_TITLE' | translate}}
      <mat-progress-bar [mode]="downloadingBackOffice ? 'determinate' : 'indeterminate'"
                            [value]="downloadingBackOffice"></mat-progress-bar>
      <div class="kt-notification">
        <div class="kt-notification__custom">
          <button class="header-button" mat-raised-button
                  matDialogClose> {{'MANUAL.CANCEL_DOWNLOAD' | translate}}</button>
        </div>
      </div>
  `
})
export class DownloadManualComponent implements OnInit, OnDestroy {
  public downloadingBackOffice: number;
  private subscription: Subscription;

  constructor(
    private manualService: ManualService,
    private matRef: MatDialogRef<DownloadManualComponent>,
  ) {
    this.matRef.disableClose = true;
  }

  ngOnInit() {
    this.downloadBackOffice();
  }

  downloadBackOffice() {
    this.subscription = this.manualService.downloadManual().subscribe(progress => {
      this.downloadingBackOffice = progress;
    }, () => this.matRef.close(), () => this.matRef.close());
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
